import { memo } from "react";
import { Card as AntCard, Avatar } from "antd";
import { useNavigate } from "react-router-dom";
import { MarkPropertyFavorites } from "../Favorite";
import { UserOutlined } from "@ant-design/icons";
import getFirstAlphabet from "@/utils/getFirstAlphabet";
import { useTranslation } from "react-i18next";
import Button from "@/common/atoms/Button";
import { ArrowRightOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useLanguage } from "@/hook/useLanguage";

const { Meta } = AntCard;

const ProfileCard = ({ profile }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  const cardDescription = () => (
    <div className="flex flex-col justify-center items-center">
      <p className="text-secondary text-center text-[20px] leading-5 font-sans break-words w-4/5 mb-1 capitalize">
        {profile?.fullName}
      </p>
      <p className="text-primary break-words text-md leading-5 font-sans mb-5 my-2">
        {profile?.noOfProperties}{" "}
        <span className="">
          {profile?.noOfProperties > 1
            ? `${t("common.properties")}`
            : `${t("common.properties")}`}{" "}
          {t("favorite.available")}
        </span>
      </p>
      <Button
        type="primary"
        className="!py-5 !px-4 rounded-xl"
        icon={isRTL ? <ArrowLeftOutlined /> : <ArrowRightOutlined />}
        iconPosition="end"
        onClick={() => navigate(`/user-profile/${profile?.favouriteUserId}`)}>
        {t("common.viewDetails")}
      </Button>
    </div>
  );

  return (
    <AntCard
      hoverable
      className="overflow-hidden rounded-2xl flex flex-col justify-center align-center static bg-white border-none shadow-[0px_0px_20px_0px_#0000001A]"
      cover={
        <div className="relative">
          <div className="mx-auto mt-8 w-[150px] h-[150px] contents-center">
            <Avatar
              shape="rounded"
              className="[&>img]:object-contain !bg-[#F2F5F7] border-[#E5E8EE] !text-[18px] text-[#0E61FF] font-manropeBold"
              size={150}
              icon={
                profile?.firstName ? (
                  getFirstAlphabet(profile?.firstName, "")
                ) : (
                  <UserOutlined />
                )
              }
              src={profile?.profilePictureUrl}
            />
          </div>
          <div className="absolute rtl:-top-5 rtl:left-3 ltr:-top-5 ltr:right-3">
            <MarkPropertyFavorites
              isFavourite={true}
              userProfileId={profile?.favouriteUserId}
              isProfileCard={true}
              fillColor="#7B9E7E"
            />
          </div>
        </div>
      }>
      <Meta description={cardDescription()} />
    </AntCard>
  );
};
export default memo(ProfileCard);
